export default __webpack_public_path__ + "static/media/sizer.7b8ad4fb.svg";